import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

/** BCP 47 primary subtag to display label mapping */
const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
  es: 'Espa\u00f1ol',
  fr: 'Fran\u00e7ais',
};

/** Resolve a BCP 47 tag (e.g. 'en-US') to its display label via primary subtag */
const getLanguageLabel = (code: string): string => {
  const primary = code.split('-')[0] ?? code;
  return (
    LANGUAGE_LABELS[code] ?? LANGUAGE_LABELS[primary] ?? code.toUpperCase()
  );
};

interface LanguageSelectProps {
  /** BCP 47 language tags available for this practice */
  supportedLanguages: string[];
  selectedLanguage: string;
  onSelectedLanguage: (value: string) => void;
}

export const LanguageSelect = ({
  supportedLanguages,
  selectedLanguage,
  onSelectedLanguage,
}: LanguageSelectProps) => {
  if (supportedLanguages.length <= 1) {
    return null;
  }

  return (
    <Select value={selectedLanguage} onValueChange={onSelectedLanguage}>
      <SelectTrigger
        className="vai-w-auto vai-max-w-[140px] vai-h-10 vai-gap-2 vai-px-4 vai-py-2 vai-text-sm vai-bg-white vai-border vai-border-input vai-rounded-md hover:vai-bg-gray-50 disabled:vai-opacity-50 disabled:vai-cursor-not-allowed [&>span]:vai-line-clamp-1 [&>svg]:vai-h-4 [&>svg]:vai-w-4"
        data-testid="language-selector"
      >
        <SelectValue placeholder="Language" />
      </SelectTrigger>
      <SelectContent className="vai-overflow-visible vai-z-[10001] vai-bg-white vai-border-gray-200 vai-text-gray-700 vai-shadow-lg vai-min-w-[8rem]">
        {supportedLanguages.map((code) => (
          <SelectItem
            key={code}
            value={code}
            className="vai-text-gray-700 hover:vai-bg-gray-50 data-[highlighted]:vai-bg-blue-50 data-[highlighted]:vai-text-blue-700 focus:vai-bg-blue-50 focus:vai-text-blue-700"
          >
            {getLanguageLabel(code)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
